import React from 'react';
import ReactDOM from 'react-dom';
import '@ifeng-fe/container_channel/common/client/commoncss/resetPC.css';
import Layout from './layout/';

/* eslint-disable */
// 初始化首屏资讯数据
const sliceInitNewsData = allData.initNewsData.sort((a, b) => {
    return Date.parse(b.newsTime) - Date.parse(a.newsTime);
});

allData.initNewsData = sliceInitNewsData;
ReactDOM.render(<Layout content={allData} />, document.getElementById('root'));
/* eslint-enable */
